
const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import {
    Typography,
    Grid2,
    Dialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    IconButton,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import CountButton from './CountButton.jsx';
import VoteButton from './VoteButton.jsx';
import ContestantSocial from './ContestantSocial.jsx';
import ContestantCustom from './ContestantCustom.jsx';
import ContestantDescription from './ContestantDescription.jsx';


class ContestantPopup extends Component {
    constructor(props) {
        super(props);
        this.state = { gtitle_color: null, title_bck: '', new_post: null, post_index: null, nppost_id: null };
    }

    toggleHover = (value) => () => {
        this.setState({ gtitle_color: value })
    }

    toggleleave = (value) => () => {
        this.setState({ gtitle_color: value })
    }

    handleNext = (post, pindex) => () => {
        this.setState({ new_post: post, post_index: pindex, nppost_id: post.id })
    }

    handlePrev = (post, pindex) => () => {
        this.setState({ new_post: post, post_index: pindex, nppost_id: post.id })
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.update_vote_count !== "undefined") {
            let last_postid = this.state.nppost_id;
            if (last_postid != null) {
                const all_posts = nextProps.posts;
                let obj = all_posts.find((val, i) => {
                    if (val.id === last_postid) {
                        this.setState({ new_post: val });
                        return i; // stop searching
                    }
                });
            }
        }
        this.setState({ new_post: null, post_index: null, nppost_id: null });
    }

    render() {

        const allprops = this.props;
        let show_desc = null;

        if (typeof allprops.custom_field !== "undefined") {
            allprops.custom_field.map(function (key, index) {
                if (key.system_name === 'contestant-desc') {
                    show_desc = key;
                }
            });
            if (show_desc)
                show_desc = show_desc.pretty_view;
        }

        //On next or previous click show the next contestant
        const post = (this.state.new_post == null) ? this.props.post : this.state.new_post;

        const { votes_cont_title_font_size, votes_cont_title_color_grid, votes_cont_title_color_hover_grid } = this.props.settings.color;
        const font_colr = votes_cont_title_color_grid;
        const font_hov_colr = votes_cont_title_color_hover_grid;
        const contest_type = this.props.short.contest_type;

        let vote_count_showhide = null;
        if (typeof this.props.short.allcatoption !== "undefined") {
            if (this.props.short.allcatoption.style) {
                vote_count_showhide = this.props.short.allcatoption.style.vote_count_showhide;
            } else {
                vote_count_showhide = (typeof this.props.settings.style !== "undefined") ? this.props.settings.style.vote_count_showhide : 'on';
            }
        }

        //Show next and previous buttons
        let post_index = (this.state.post_index == null) ? this.props.post_index_val : this.state.post_index;
        //const all_posts = (typeof this.props.posts !== "undefined")?this.props.posts:null;
        const all_posts = (typeof this.props.posts === "undefined") ? this.props.post_single : this.props.posts;
        let nextpost = (post_index + 1);
        let prevpost = (post_index - 1);
        let next_post_show = 0; let prev_post_show = 0;
        if (all_posts != null) {
            if (typeof all_posts[nextpost] !== "undefined") {
                next_post_show = 1;
            }
            if (typeof all_posts[prevpost] !== "undefined") {
                prev_post_show = 1;
            }
        }
        if (post) {
            let image_size = post.popup_image != null ? post.popup_image : post.featured_image_url;

            const button_status = (typeof post.vote_button_status !== "undefined") ? post.vote_button_status : null;
            const butn_msg = (typeof button_status === "object" && button_status != null) ? button_status.update_vote_count.msg : true;

            return (
                (<Dialog onClose={this.props.handlemodal} className="wpvc_contestant_popup_container" aria-labelledby="customized-dialog-title" open={this.props.open_val == 1 ? true : false}>
                    <MuiDialogTitle component="div" className="wpvc_contestant_popup_title" onClose={this.props.handlemodal}>
                        <Typography
                            variant="h5"
                            className="wpvc_grid_header"
                            style={{ fontSize: votes_cont_title_font_size + 'px', 'color': this.state.gtitle_color }}
                            onMouseOver={this.toggleHover(font_hov_colr, 'title')}
                            onMouseLeave={this.toggleleave(font_colr, 'title')}
                        >
                            {post.post_title}
                        </Typography>

                        {prev_post_show == 1 &&
                            <IconButton component="a" onClick={this.handlePrev(all_posts[prevpost], prevpost)}>
                                <NavigateBeforeIcon className="wpvc_prev_post" />
                            </IconButton>
                        }

                        {next_post_show == 1 &&
                            <IconButton component="a" onClick={this.handleNext(all_posts[nextpost], nextpost)}>
                                <NavigateNextIcon className="wpvc_next_post" />
                            </IconButton>
                        }

                        <IconButton aria-label="close" onClick={this.props.handlemodal}>
                            <CloseIcon />
                        </IconButton>
                    </MuiDialogTitle>
                    <MuiDialogContent dividers className="wpvc_contestant_popup_content" >
                        <Grid2 container className="wpvc_showcontestant_popup_container">
                            <Grid2 container size={12} className="wpvc_contestant_btn_container" columnSpacing={2}>
                                {
                                    vote_count_showhide === 'on' &&
                                    <CountButton {...allprops} singlepost={post} view="grid" />
                                }
                                {this.props.vote_time == null &&

                                    <VoteButton {...allprops} singlepost={post} indexpost={post_index} view="grid" currentdate={this.props.currentdate} setButtonText={this.props.setButtonText} button_msg={butn_msg} wait={0} />

                                }
                            </Grid2>

                            <Grid2 container size={12} className="wpvc_popup_item_socbtns" direction="row" justifyContent="center" alignItems="center">
                                <ContestantSocial {...allprops} singlepost={post} view="grid" />
                            </Grid2>


                            <Grid2 className="wpvc_popup_grid_item" size={12}>

                                {(contest_type == 'photo' || contest_type == 'essay') &&
                                    <img className={"wpvc_contestant_popup_image"} src={image_size} title={post.post_title} />
                                }

                                {
                                    show_desc != 'N' && show_desc != '' &&
                                    <ContestantDescription {...allprops} singlepost={post} view="single" />
                                }
                            </Grid2>

                            <Grid2 className="wpvc_popup_grid_custom" size={12}>
                                <ContestantCustom {...allprops} singlepost={post} header="1" view="popup" currentdate={this.props.currentdate} />
                            </Grid2>
                        </Grid2>
                    </MuiDialogContent>
                </Dialog>)
            );
        } else {
            return ''
        }
    }
}

export default connect()(withTranslation("translations")(ContestantPopup));
